import React, { useEffect } from 'react';
import {SurveyPagePropTypes, useAnswers, NeuroMessage, useDispatch, logout, usePages, Tooltip} from '@ignitesales/neuro-application';
import { DonutChart } from '@ignitesales/neuro-application/src/neuro-ui';
import {useRouteMatch} from 'react-router-dom';
import { loadUrlParameters } from '../../utils/saveParameters.mjs';

const SurveyPage = ({ className, componentClass, renderQuestionGroups }) => {
  const { answers = {} } = useAnswers();
  const matchSurveyCommerce = useRouteMatch('/guide/spa/:uuid/entry/personalBalancesCommerce-page');
  const matchSurveyExternal = useRouteMatch('/guide/spa/:uuid/entry/personalBalancesExternal-page');
  const matchSurveyLookup = useRouteMatch('/guide/spa/:uuid/entry/lookup-page');
  const dispatch = useDispatch();
  const { currentPageUrl } = usePages();
  const isBusinessExpansionPage = currentPageUrl.includes("businessExpansion-page"); 
  
  useEffect(() => {
    const checkLoginStatus = async () => {
      const getGuideAttributes = await window.ignite.userService.getGuideAttributes();
      const sessionTime = window.localStorage.getItem('sessionStartTime');
      const shouldLogout = sessionTime ? (Date.now() - sessionTime) > (getGuideAttributes.sessionTimeout || 14400000) : true; 
      const { isLoggedIn } =  await window.ignite.employeeLoginService.shouldEmployeeLogin();
      if (isLoggedIn && shouldLogout) {
        dispatch(logout());
        window.localStorage.removeItem('sessionStartTime');
      }
      loadUrlParameters();
    };
    matchSurveyLookup && checkLoginStatus();
  }, []);


  let data = [];
  
  if(matchSurveyCommerce) {
    data = [
      answers?.commercePersonalChecking,
      answers?.commercePersonalSavings,
      answers?.commercePersonalIra,
    ].filter(val => val?.value > 0)
  } else if(matchSurveyExternal) {
    data = [
      answers?.externalPersonalChecking,
      answers?.externalPersonalSavings,
      answers?.externalPersonalIra,
    ].filter(val => val?.value > 0);
  }
  const colors = {
    commercePersonalChecking: '#006747',
    commercePersonalSavings: '#78be20',
    commercePersonalIra: '#676c67',
    externalPersonalChecking: '#006747',
    externalPersonalSavings: '#78be20',
    externalPersonalIra: '#676c67',
  };

  const legendProps = {
    align: 'center',
    verticalAlign: 'bottom',
    layout: 'horizontal'
  }


  // Tooltip for businessExpansion dynamic question title
  const tooltip = (messageKey) => {
    const tooltipAttributes =  { attributes: { tooltip: { place: "bottom" } } };
    return (
      <NeuroMessage id={`${messageKey}.tooltip`} key={`${messageKey}.tooltip`} shouldHideIfNotFound={true}>
        {() => <Tooltip className={`questionGroupHeader__tooltip`} messageId={`${messageKey}.tooltip`} {...tooltipAttributes} /> }
      </NeuroMessage>
    );
  }

  const renderBusinessExpansionPageHeader = () => {
    const isCurrentBusinessCustomer = !!answers?.bankingRelationship?.value?.length && answers?.bankingRelationship?.value?.some(value => value === 'business' || value === 'both');
    const customerType = isCurrentBusinessCustomer ? 'existingBusinessCustomer' : 'newBusinessCustomer';
    return (
      <div className='businessExpansion-header'>
        <NeuroMessage id={`businessExpansion-group.${customerType}`} tagName='h1' />
        {isCurrentBusinessCustomer && tooltip('businessExpansion-group.existingBusinessCustomer')}
      </div>
    );
  }

  return (
    <div className={className}>
      <div className={`questionGroups ${componentClass}__questionGroups`}>
        
        { isBusinessExpansionPage && renderBusinessExpansionPageHeader() }
        { renderQuestionGroups() }
        
          {(matchSurveyCommerce || matchSurveyExternal) && data.length > 0 ?
            <div className="questionGroup chartContainer">
              <DonutChart
                header={'combinedAccountBalance'}
                data={data}
                colors={colors}
                centerLabel={`$${data.reduce((a, b) => a + b?.value, 0).toLocaleString() || '0'}`}
                legendProps={legendProps}
              
            /></div> : (matchSurveyCommerce || matchSurveyExternal) &&
            <div className="questionGroup chartContainer">
              <div className="placeholder">
                <div className="placeholder--graph">
                  <NeuroMessage id="combinedAccountBalance.info" tagName='p' />
                </div>
              </div>
            </div>
          }

      </div>
    </div>
  );
};

SurveyPage.propTypes = SurveyPagePropTypes;

export default SurveyPage;
